export default __webpack_public_path__ + "static/media/DAIF_Home_Loop.d8c873ea.mp4";